import { Box } from '@mui/material'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'

import Stepper from '@/components/Stepper'
import NewKonvaCanvas from '@/components/canvas/NewKonvaCanvas'
import ImageEdit from '@/components/imageEdit/ImageEdit'
import { useCanvasSize } from '@/hooks/useCanvasSize'
import CaseInfoLayout from '@/layout/CaseInfoLayout'
import { useAppSelector } from '@/store'
import { getDehazedImageUrl } from '@/utils/helper'

import ShadeGuidePanel from './panel/ShadeGuidePanel'
import { SHADE_GUIDE_STEPS } from './utils/constants'

const ShadeGuideAi = () => {
  const canvasImage = useAppSelector((state) => state.app.canvasImage)
  const shadeGuideActiveStep = useAppSelector(
    (state) => state.shadeGuide.shadeGuideActiveStep,
  )
  const { containerRef, dimensions } = useCanvasSize()
  const [isHovered, setIsHovered] = useState(false)

  const onImageClick = () => {}

  const path = useLocation().pathname
  const imageEdit = useAppSelector(
    (state) => state.app.imageEdit[path] || false,
  )

  return (
    <CaseInfoLayout rightPanel={<ShadeGuidePanel />}>
      <Box display="flex" flexDirection="column" flexGrow={1}>
        <Box>
          <Stepper
            steps={SHADE_GUIDE_STEPS}
            activeStep={shadeGuideActiveStep}
          />
        </Box>
        <Box ref={containerRef} display="flex" flexGrow={1}>
          {!imageEdit ? (
            <NewKonvaCanvas
              type={canvasImage?.type}
              imageUrl={
                getDehazedImageUrl(canvasImage) ||
                canvasImage?.latest_image ||
                canvasImage?.calibrated_image ||
                canvasImage?.image
              }
              width={dimensions.width}
              height={dimensions.height}
              onImageClick={onImageClick}
              imageId={canvasImage?.id}
              rawWidth={canvasImage?.raw_width}
              rawHeight={canvasImage?.raw_height}
              isActiveCircle={isHovered}
              onHoverChange={setIsHovered}
            />
          ) : (
            <Box width={dimensions.width} height={dimensions.height}>
              <ImageEdit selectedImage={canvasImage} />
            </Box>
          )}
        </Box>
      </Box>
    </CaseInfoLayout>
  )
}

export default ShadeGuideAi
